import type { FieldProps } from 'formik';
import type { PropsWithChildren } from 'react';

import {
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
} from '@frontend/components';

import type {
  SupportFormData,
  SupportFormFieldName,
  SupportFormFieldValue,
} from '../types';

export type SupportFormControlProps<FieldName extends SupportFormFieldName> =
  PropsWithChildren<{
    fieldProps: FieldProps<SupportFormFieldValue<FieldName>, SupportFormData>;
    name: FieldName;
    label: string;
    isRequired?: boolean;
    helpText?: string;
  }>;

export const SupportFormControl = <FieldName extends SupportFormFieldName>({
  fieldProps: { form },
  name,
  label,
  isRequired,
  helpText,
  children,
}: SupportFormControlProps<FieldName>) => {
  const error = form.errors[name];
  const isValid = !error;
  const isTouched = !!form.touched[name];

  const errorMessage = typeof error === 'string' ? error : undefined;

  return (
    <FormControl isInvalid={isTouched && !isValid} isRequired={isRequired}>
      <FormLabel>{label}</FormLabel>
      {children}
      {errorMessage && <FormErrorMessage>{errorMessage}</FormErrorMessage>}
      {helpText && <FormHelperText>{helpText}</FormHelperText>}
    </FormControl>
  );
};
